const TokenKey = 'kuPengo'
const UserInfo = 'userInfo'
const ShopId   = 'shop_id'

export const getCookie = function (key) {
    return localStorage.getItem(key)
}

export const setCookie = function (key, token) {
    return localStorage.setItem(key, token)
}

export const getToken = function () {
    return localStorage.getItem(TokenKey)
}

export const setToken = function (token) {
    return localStorage.setItem(TokenKey, token)
}

export const removeToken = function () {
    return localStorage.removeItem(TokenKey)
}

export const getUser = function () {
    return localStorage.getItem(UserInfo)
}

export const setUser = function (info) {
    return localStorage.setItem(UserInfo, info)
}

export const getShop = function () {
    return localStorage.getItem(ShopId)
}

export const setShop = function (info) {
    localStorage.setItem(ShopId, info.id)
    localStorage.setItem('ShopName', info.shop_name)
    localStorage.setItem('shop', JSON.stringify(info))
}

export default {
    getCookie,
    setCookie,

    getToken,
    setToken,
    removeToken,

    getUser,
    setUser,

    getShop,
    setShop
}
